import React, { useState, useEffect } from "react";
import { VectorMap } from "@south-paw/react-vector-maps";
import MouseTooltip from "react-sticky-mouse-tooltip";
import bulgaria from "./bulgaria.json";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import "./styles.scss";

const Map = ({ onClickChange, isMobile }) => {
  const style = { backgroundColor: "#white", color: "#white" };
  const [isMouseTooltipVisible, setMouseTooltipVisible] = useState();
  const [current, setCurrent] = useState(null);
  const [hovered, setHovered] = useState("");
  const [focused, setFocused] = useState("None");

  const toggleMouseTooltip = () => {
    setMouseTooltipVisible(!isMouseTooltipVisible);
  };

  const layerProps = {
    onMouseEnter: ({ target }) => setHovered(target.attributes.name.value),
    onMouseLeave: () => setHovered(""),
    onFocus: ({ target }) => setFocused(target.attributes.name.value),
    onBlur: () => setFocused("None"),
    onClick: ({ target }) => {
      onClickChange(target.attributes.name.value);
    },
  };

  useEffect(() => {
    toggleMouseTooltip();
  }, []);

  if (
    typeof window !== "undefined" &&
    window.location.pathname === "/single-discount"
  ) {
    return (
      <>
        <div style={style} className="">
          <div className="map-style max-width">
            <VectorMap
              {...bulgaria} tabIndex={2}
              layerProps={layerProps}
            />

            <MouseTooltip
              visible={isMouseTooltipVisible}
              offsetX={15}
              offsetY={10}
              className="mouse-tooltip"
            >
              <span>{hovered}</span>
            </MouseTooltip>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        {isMobile
          ? <div style={style}>
            <div className="map-style">
              <VectorMap
                {...bulgaria}
                layerProps={layerProps}
                currentLayers={[current]}
              />

              <MouseTooltip
                visible={isMouseTooltipVisible}
                offsetX={15}
                offsetY={10}
                className="mouse-tooltip"
              >
                <span>{hovered}</span>
              </MouseTooltip>

              <div className="map-city-list">
                <ul className='p-0'>
                  {bulgaria.layers.map(({ id, name }) => (
                    <li key={id}>
                      <code
                        role="button"
                        layerProps={layerProps}
                        onMouseOver={() => onClickChange(name)}>
                        {<LocationOnIcon />}{name}
                      </code>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          : <div style={style}>
            <div className="map-style map-styling">
              <VectorMap
                {...bulgaria} tabIndex={2}
                layerProps={layerProps}
              />

              <MouseTooltip
                visible={isMouseTooltipVisible}
                offsetX={15}
                offsetY={10}
                className="mouse-tooltip"
              >
                <span>{hovered}</span>
              </MouseTooltip>
            </div>
          </div>}
      </>
    );
  }
};

export default Map;
